export const letterText = {
  fontSize: { base: 'base', md: 'md' },
  lineHeight: 'relaxed',
  color: 'text.secondary',
  textWrap: 'pretty',
  margin: '0',
} as const;
